import React from "react";

const Logo = ({ className = "" }) => {
  return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="383.41"
            height="257.689"
            viewBox="0 0 383.41 257.689"
            >
            <g transform="translate(191.705 128.844) translate(-155 -90)">
                
                <g transform="scale(1,-1) translate(0,-220)">
                <path
                    d="
                    M120 20
                    C60 20 20 65 20 110
                    C20 155 60 200 120 200
                    C155 200 185 185 205 160
                    L180 140
                    C165 160 145 170 120 170
                    C80 170 55 140 55 110
                    C55 80 80 50 120 50
                    C150 50 170 65 180 85
                    L120 85
                    L120 115
                    L220 115
                    C220 60 185 20 120 20
                    Z
                    "
                />
                </g>

                <path
                d="
                    M250 20
                    L250 200
                    L330 200
                    L330 170
                    L285 170
                    L285 125
                    L325 125
                    L325 95
                    L285 95
                    L285 50
                    L330 50
                    L330 20
                    Z
                "
                />
            </g>
            </svg>

  );
};

export default Logo;

